export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-10.b1e2cf07.svg";